module.exports = __webpack_public_path__ + "static/media/arrowRight.845b6bfd.svg";